<template>
  <el-table :data="dataList" border style="width: 100%">
    <el-table-column
      type="index"
      header-align="center"
      align="center"
      width="50"
      label="行号"
    ></el-table-column>
    <el-table-column
      prop="code"
      label="品番号"
      header-align="center"
      align="center"
    ></el-table-column>
    <el-table-column
      prop="name"
      label="产品名称"
      header-align="center"
      align="center"
    >
    </el-table-column>
    <el-table-column
      prop="color"
      label="颜色"
      header-align="center"
      align="center"
    ></el-table-column>
    <el-table-column
      prop="size"
      label="尺寸"
      header-align="center"
      align="center"
    ></el-table-column>
    <el-table-column
      prop="attr1"
      label="规格"
      header-align="center"
      align="center"
    ></el-table-column>
    <el-table-column
      prop="attr2"
      label="其他"
      header-align="center"
      align="center"
    ></el-table-column>
    <el-table-column
      prop="count"
      label="数量"
      header-align="center"
      align="center"
    >
      <template slot-scope="scope">
        <div>合同数量：{{ scope.row.count }}</div>
        <div>完成数量：{{ scope.row.completeCount }}</div>
      </template>
    </el-table-column>
    <el-table-column label="单价" header-align="center" align="center">
      <template slot-scope="scope">
        {{ moneyFormat(scope.row.amount) }}
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  components: {},
  props: {
    dataList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {};
  },
  watch: {},
  methods: {},
};
</script>
